import type { IServerEventName } from '@/services/transport/serverEvents'

export const FILTERED_VIEW_CREATED_EVENT_ID = 'filteredViewCreated' as const satisfies IServerEventName
export const FILTERED_VIEW_DELETED_EVENT_ID = 'filteredViewDeleted' as const satisfies IServerEventName
export const FILTERED_VIEW_CACHE_CLEAR_EVENT_ID = 'filteredViewCacheClear' as const satisfies IServerEventName
export const FILTERED_VIEW_COUNT_UPDATED_EVENT_ID = 'filteredViewCountUpdated' as const satisfies IServerEventName
